import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { FloatingCTA } from './components/FloatingCTA';
import { PurchasePopup } from './components/PurchasePopup';
import { Footer } from './components/Footer';
import { Hero } from './components/sections/Hero';
import { PainSection } from './components/sections/PainSection';
import { KnowledgeSection } from './components/sections/KnowledgeSection';
import { BeforeAfter } from './components/sections/BeforeAfter';
import { Objections } from './components/sections/Objections';
import { CreatorApproach } from './components/sections/CreatorApproach';
import { Volumes } from './components/sections/Volumes';
import { IncludedTools } from './components/sections/IncludedTools';
import { RepeatableProcess } from './components/sections/RepeatableProcess';
import { Bonuses } from './components/sections/Bonuses';
import { Offer } from './components/sections/Offer';
import { Guarantee } from './components/sections/Guarantee';
import { Testimonials } from './components/sections/Testimonials';
import { Author } from './components/sections/Author';
import { Faq } from './components/sections/Faq';
import { FinalCTA } from './components/sections/FinalCTA';
interface AppProps {
  showPurchasePopup?: boolean;
  showFloatingCta?: boolean;
}
export function App({
  showPurchasePopup = true,
  showFloatingCta = true
}: AppProps) {
  return <div className="w-full bg-cream" data-id="element-0" data-mp="2zllen0i82im7">
      <MetaPixel data-id="element-1" data-mp="2zmo4d53t6f0j" />

      <main className="w-full" data-id="element-2" data-mp="2zn6biws0edn8">
        <Hero data-id="element-3" data-mp="33mf623uvifju" />
        <PainSection data-id="element-4" data-mp="33lwzoeehyky7" />
        <KnowledgeSection data-id="element-5" data-mp="33ngiabnml835" />
        <BeforeAfter data-id="element-6" data-mp="33orla998ybt7" />
        <Objections data-id="element-7" data-mp="38m1gy6n8bjph" />
        <CreatorApproach data-id="element-8" data-mp="38li7lebna3n2" />
        <Volumes data-id="element-9" data-mp="38k6uup081ljt" />
        <IncludedTools data-id="element-10" data-mp="38nuodo5o27yj" />
        <RepeatableProcess data-id="element-11" data-mp="3dkurprb4swly" />
        <Bonuses data-id="element-12" data-mp="3dl4k1ljnffut" />
        <Offer data-id="element-13" data-mp="3dlnwwnufze1z" />
        <Guarantee data-id="element-14" data-mp="3dm5zs3bm0qiv" />
        <Testimonials data-id="element-15" data-mp="3dii716dzo857" />
        <Author data-id="element-16" data-mp="nw2ci75e7srm" />
        <Faq data-id="element-17" data-mp="nuhh6fb985sp" />
        <FinalCTA data-id="element-18" data-mp="nuraabrlit2m" />
      </main>

      <Footer data-id="element-19" data-mp="nxww9i4xheu4" />

      {showFloatingCta && <FloatingCTA data-id="element-20" data-mp="stuejtzr4v9j" />}
      {showPurchasePopup && <PurchasePopup data-id="element-21" data-mp="ssss6tdacmci" />}
    </div>;
}